import { request } from './request'

// 攻击防护排名
export const getAttackDefenseRanking = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/attack_protection_ranking`)

// 危险等级分布
export const getRiskLevelDistribution = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/risk_level_distribution`)

// 用例等级分布
export const getResourceLevelsRanking = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/resource_level_distribution`)

// 模板防护失效率排名
export const getTemplateLoseEfficacyRanking = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/template_protection_ranking`)

// 验证结果分布
export const getVerifyDistribution = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/intercept_status_distribution`)

// 设备防护列表
export const getDeviceProtectionList = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/device_protection_ranking`)

// 获取筛选聚合数据
export const getResourceFilterData = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/filter_data`)

// 获取离线日志导入信息
export const getOfflineLogImportInfo = data =>
  request(`/portal/v1/wg/results/${data.resultId}/get_log_device_import_records`)

// 删除日志设备导入记录
export const deleteOfflineLogImportRecord = data =>
  request(`/portal/v1/wg/results/${data.resultId}/log_device_import_record/${data.id}`, {
    method: 'delete',
    timeout: 60000,
  })
